import { render, staticRenderFns } from "./RecentlyAddedArticles.vue?vue&type=template&id=67c8f678&"
import script from "./RecentlyAddedArticles.vue?vue&type=script&lang=ts&"
export * from "./RecentlyAddedArticles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports